module.exports = __webpack_public_path__ + "img/visa-primary-large.40a24129.png";